module.exports = __webpack_public_path__ + "files/fea1c44165b267120b119017ed184ad0.png";